const headerMenuMobileSelectBtn = document.querySelectorAll('.header-menu-mobile__select-btn')
const headerMenuMobileMenuDesktop = document.querySelectorAll('.header-menu-mobile__menu-desktop')
const headerMenuMobileArrow = document.querySelectorAll('.header-menu-mobile__arrow')
const headerMenuMobileBtn = document.querySelectorAll('.header-menu-mobile__btn')

for (let i = 0; i < headerMenuMobileSelectBtn.length; i++) {

  headerMenuMobileSelectBtn[i].addEventListener('click', () => {
    headerMenuMobileMenuDesktop[i].classList.toggle('header-menu-mobile__menu-desktop--open')
    headerMenuMobileArrow[i].classList.toggle('header-menu-mobile__arrow--animation')
    headerMenuMobileBtn[i].classList.toggle('header-menu-mobile__btn--active')
  })
}
